import { Role } from '@guiker/permissions'

import { InvestorProfileActions } from './actions'
import { AdminRoleNames } from './role-names'

export const InvestorProfileReviewer: Role = {
  name: AdminRoleNames.INVESTOR_PROFILE_REVIEWER,
  permissions: [{ action: InvestorProfileActions.reviewInvestorProfile }],
}
